import React from 'react'
import Text from 'Components/shared/text';
import Button from 'Components/shared/button';

import styles from '../transfer_components.module.css';
import Back from 'Components/main_components/registeration/Back';
import { useGetBeneficiaries } from 'services/transferService';

const Summary = ({onNext, onPrevious, ...props}) => {
    const {values} = props;
    const {data: beneficiaries} = useGetBeneficiaries();
    const receiver = beneficiaries?.find(benefit => benefit.beneficiaryId === values.beneficiary) || {}
    return (
        <div className={`text-center ${styles.Summary}`}>
            {/* <Back onClick={onPrevious} /> */}
            <Text variant="lg" style={{fontWeight:700}}>Review Payment</Text>
            <Text variant="xl" style={{fontWeight:700}}>
                Confirm <Text tag="span" variant="xl" style={{fontWeight:700, color:"var(--secondary-color)"}}>{values.amount} </Text>
                  payment to {`${receiver.accountName} - ${receiver.accountNumber} - ${receiver.bank} `} 
            </Text>
            <Text color="secondary" variant="xs">
                Please confrim thet the details above are correct. Submitted payments cannot be recalled
            </Text>
            <Button onClick={() => onNext()} fullWidth style={{marginTop:"40px"}}>
                Continue
            </Button>
        </div>
    )
}

export default Summary;